import { errorTypes } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRuleDetailConfiguration/constants'

import { discountTypeValues } from './constants'

export const isFixedDiscount = config => {
  return Boolean(config.bonus_exchange_discount) && config.bonus_exchange_discount_type === discountTypeValues.fixed
}

export const getErrors = errors => ({
  hasError: errors.some(e => e.type === errorTypes.actionBonusOptionsEmpty),
  hasDiscountTypeError: errors.some(e => e.type === errorTypes.actionBonusDiscountTypeEmpty),
  hasDiscountLabelError: errors.some(e => e.type === errorTypes.actionBonusDiscountLabelEmpty),
  hasDiscountValueError: errors.some(e => e.type === errorTypes.actionBonusDiscountValueEmpty),
  hasProductConditionError: errors.some(e => e.type === errorTypes.actionProductConditionIncomplete),
})
